import { cn } from "@/lib/cn";

import "./CalendarCell.css";

interface CalendarCellProps {
  day: number;
  bgClass: string;
  textClass: string;
  isSelected?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const CalendarCell = ({
  day,
  bgClass,
  textClass,
  isSelected = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: CalendarCellProps) => {
  return (
    <button
      type="button"
      className={cn(
        // Base class with dashed ring on hover/selected
        "calendar-cell",
        // Layout - 24px согласно Figma
        "flex flex-col items-center justify-center",
        "size-6 shrink-0",
        // Shape
        "rounded-full",
        // Typography - fs-100 (11.11px, bold)
        "fs-100 text-center font-bold",
        // Colors from CSS variables
        bgClass,
        textClass,
        // Interaction
        "cursor-pointer",
        // Selected state
        isSelected && "is-selected"
      )}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <span>{day}</span>
    </button>
  );
};

// Пустая ячейка для заполнения начала/конца месяца
export const EmptyCell = () => <div className="size-6 shrink-0" />;
